import { ReactNode } from "react";

import { cx } from "@/lib/tailwind-utils";

export function StatusScreen({
  title,
  message,
  action,
  className,
}: {
  title: string;
  message: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cx(
        "flex min-h-full w-full items-center justify-center bg-background p-8",
        className,
      )}
    >
      <div className="max-w-md rounded-2xl border border-border bg-card p-8 text-center shadow-sm">
        <h1 className="mb-3 text-h2 text-foreground">{title}</h1>
        <p className="text-body text-foreground-secondary">{message}</p>
        {action && <div className="mt-6">{action}</div>}
      </div>
    </div>
  );
}
